import React from "react";
import { Link } from "react-router-dom";
import SEO from "@/components/SEO";
import BreadcrumbNav from "@/components/BreadcrumbNav";
import ProcessSteps from "@/components/ProcessSteps";
import WhyBlackRidge from "@/components/WhyBlackRidge";
import CTASection from "@/components/CTASection";
import { SERVICE_CATEGORIES, slugToTitle } from "@/data/services";
import { ArrowRight } from "lucide-react";

const BREADCRUMBS = [{ label: "Home", to: "/" }, { label: "Construction Services" }];

export default function Services() {
  return (
    <>
      <SEO title="Construction Services Austin TX | Black Ridge Construction" description="Full-service general contractor in Austin, TX. Roofing, remodeling, additions, outdoor living, exterior, repairs, and maintenance — every residential trade under one team." />

      <section className="bg-br-black text-white">
        <div className="container-br py-12 lg:py-16">
          <BreadcrumbNav dark items={BREADCRUMBS} />
          <div className="max-w-3xl mt-5">
            <div className="br-eyebrow text-br-bronze-2">Full-Service General Contractor</div>
            <h1 className="br-headline text-4xl sm:text-5xl mt-3">Construction & Remodeling Services in Austin, TX</h1>
            <p className="mt-4 text-gray-300">Black Ridge Construction operates as a real general contractor for Central Texas homeowners. We coordinate roofing, remodeling, additions, repairs, exterior work, and ongoing maintenance — so you only manage one relationship instead of many. Below is a complete view of the trades and project types we handle.</p>
          </div>
        </div>
      </section>

      <section className="section-pad bg-br-paper">
        <div className="container-br space-y-12">
          {SERVICE_CATEGORIES.map((cat) => (
            <div key={cat.title}>
              <div className="flex items-end justify-between mb-4">
                <h2 className="br-headline text-2xl sm:text-3xl">{cat.title}</h2>
                <div className="hidden sm:block divider-bronze" />
              </div>
              <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
                {cat.services.map((slug) => (
                  <Link to={`/services/${slug}`} key={slug} className="group p-5 bg-white border border-gray-200 rounded hover:border-br-bronze hover:shadow-md transition flex items-start justify-between gap-3">
                    <div>
                      <div className="font-display tracking-widest uppercase text-sm">{slugToTitle(slug)}</div>
                      <div className="text-xs text-gray-500 mt-1">Learn more about our Austin-area {slugToTitle(slug).toLowerCase()} work.</div>
                    </div>
                    <ArrowRight size={16} className="text-br-bronze mt-1 group-hover:translate-x-1 transition" />
                  </Link>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="section-pad bg-white">
        <div className="container-br">
          <div className="max-w-2xl mb-8">
            <div className="br-eyebrow">Why Black Ridge</div>
            <h2 className="br-headline text-3xl sm:text-4xl mt-3">Built for Long-Term Homeowner Relationships</h2>
          </div>
          <WhyBlackRidge />
        </div>
      </section>

      <section className="section-pad bg-br-paper">
        <div className="container-br">
          <div className="max-w-2xl mb-8">
            <div className="br-eyebrow">Our Process</div>
            <h2 className="br-headline text-3xl sm:text-4xl mt-3">Predictable Steps. Clear Communication.</h2>
          </div>
          <ProcessSteps />
        </div>
      </section>

      <CTASection />
    </>
  );
}
